import { render, staticRenderFns } from "./AggregatorEditor.vue?vue&type=template&id=03d46afc&"
import script from "./AggregatorEditor.vue?vue&type=script&lang=js&"
export * from "./AggregatorEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d46afc')) {
      api.createRecord('03d46afc', component.options)
    } else {
      api.reload('03d46afc', component.options)
    }
    module.hot.accept("./AggregatorEditor.vue?vue&type=template&id=03d46afc&", function () {
      api.rerender('03d46afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/AggregatorEditor.vue"
export default component.exports